import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Play, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * VideoSection - Minimal CTA section for homepage
 * Links to the dedicated /cooking-videos page
 */
export const VideoSection = () => {
  const [hasVideos, setHasVideos] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkForVideos();
  }, []);

  const checkForVideos = async () => {
    try {
      const response = await axios.get(`${API}/videos/featured`);
      setHasVideos(response.data.length > 0);
    } catch (error) {
      console.error('Failed to check videos:', error);
    } finally {
      setLoading(false);
    }
  };

  // Don't render if no videos exist or still loading
  if (loading || !hasVideos) {
    return null;
  }

  return (
    <section className="py-14 md:py-20 bg-[#2A2A2A]" data-testid="video-cta-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#D4540A]/15 mb-6">
          <Play className="w-7 h-7 text-[#D4540A]" fill="#D4540A" />
        </div>
        <h2 className="font-['Bodoni_Moda'] text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-3">
          Want to see Country Bo in action?
        </h2>
        <p className="text-[#B8B5B0] text-base sm:text-lg mb-8 max-w-xl mx-auto">
          Watch real recipes and see how our seasonings transform everyday meals.
        </p>
        <Link to="/cooking-videos">
          <Button
            size="lg"
            className="bg-[#D4540A] hover:bg-[#B84709] text-white px-8 py-6 text-base font-semibold rounded-full transition-all hover:scale-105"
            data-testid="watch-cooking-videos-btn"
          >
            Watch Cooking Videos
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default VideoSection;
